import { columnSettings, tableWidth } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    product_name,
    category_name,
    total_quantity,
    product_price,
    sub_total,
    discount,
    grand_total,
  } = props;

  const numberFormat = (number) => {
    // not currency
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  return (
    <tr
      key={mykey}
      className={`row-start-start ${tableWidth} text-sm text-slate-700 !items-stretch`}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["product_name"].layout} ${settings["product_name"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {product_name}
      </td>

      <td
        className={`${settings["total_quantity"].layout} ${settings["total_quantity"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(total_quantity)}
      </td>

      <td
        className={`${settings["product_price"].layout} ${settings["product_price"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(product_price ?? 0)}
      </td>

      <td
        className={`${settings["sub_total"].layout} ${settings["sub_total"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(sub_total)}
      </td>

      <td
        className={`${settings["discount"].layout} ${settings["discount"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(discount)}
      </td>

      <td
        className={`${settings["grand_total"].layout} ${settings["grand_total"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(grand_total)}
      </td>
    </tr>
  );
};

export default ReportTemplateDetail;
